import { render, staticRenderFns } from "./AssignmentHeader.vue?vue&type=template&id=7e7307c8&scoped=true&"
import script from "./AssignmentHeader.vue?vue&type=script&lang=js&"
export * from "./AssignmentHeader.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentHeader.vue?vue&type=style&index=0&id=7e7307c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7307c8",
  null
  
)

export default component.exports